import { ReactNode } from 'react';

import { Text } from '../../cdl/Text/Text';
import { Box } from '../ui/Box';

interface SectionProps {
    // The Contents of section
    children: ReactNode;
    // The title of a section
    title?: ReactNode;
    // Actions of a section that are shown in the upper right corner
    actions?: ReactNode;
    // Wether the section should take up the full height of its parent
    fullHeight?: boolean;
    // The horizontal padding inside the section's content
    paddingY?: number;
}

export const Section = (props: SectionProps) => {
    const { title, children, actions, fullHeight = true, paddingY = 16 } = props;

    return (
        <Box display="flex" height={fullHeight ? '100%' : 'auto'} flexDirection="column" position="relative">
            {(title || actions) && (
                <Box
                    display="flex"
                    paddingBottom="12px"
                    borderBottomStyle="solid"
                    borderBottomWidth="1px"
                    borderColor="border.muted"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    {title && (
                        <Text variant="title" as="h2" margin={0}>
                            {title}
                        </Text>
                    )}
                    {actions && <Box>{actions}</Box>}
                </Box>
            )}

            <Box paddingY={paddingY} height="100%" width="100%">
                {children}
            </Box>
        </Box>
    );
};
